import { render } from "./PatientHomeMonitoringActionModal.vue?vue&type=template&id=3a7e6299&ts=true"
import script from "./PatientHomeMonitoringActionModal.vue?vue&type=script&lang=ts"
export * from "./PatientHomeMonitoringActionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__